export default {"src":"/_next/static/media/home-header-vertical-line.f89a7df4.svg","height":10,"width":1};